import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyProjectsMessage: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.empty-content.empty-projects-message',
		defaultMessage: "Once you visit or create projects, they'll show up here.",
		description: "Message shown to user when they don't have any projects",
	},
});
